import { useQuery } from "react-query";
import axiosInstance from "../config/Axios";
import { useSelector } from "react-redux";

const fetchDashboardData = async () => {
  const response = await axiosInstance.get(`/dashboard`);
  return response.data.data;
};

export const useFetchDashboardData = () => {
  const { isAuthenticated } = useSelector((state) => state.global);

  return useQuery({
    queryKey: ['dashboardData'],
    queryFn: fetchDashboardData,
    staleTime: 5 * 60 * 1000,
    // The "N Online/Offline Screens" tiles read this data — previously only
    // refreshed by an unrelated RTDB trigger path (Dashboard/{company}/action)
    // that device presence changes don't write to, so it could sit stale for
    // the full 5-minute staleTime. Poll at the same 15s cadence as the rest
    // of the online-status surfaces.
    refetchInterval: 15000,
    refetchOnWindowFocus: false,
    retry: 2,
    enabled: isAuthenticated,
  });
};
